export enum AnalyticPrefix {
  WEEDS = 'DroneWeeds'
}
